// test187
(187 && 0);
